class ChooseAvatarFullModalController {

    constructor() {

        this.template = Handlebars.compile($("#chooseAvatarFullModal").html());
        this.menuTemplate = Handlebars.compile($("#fullModalMenu").html());

        this.onClose = undefined;
        this.welcomeScreen = undefined;
        this.url = undefined;
        this.base64Image = undefined;

        var that = this;

        $(document).on("click", '#choose-avatar-upload-image-btn', function(e) {
            e.preventDefault();
            $('#choose-avatar-upload-image-input').trigger('click');
            return false;
        });

        $(document).on("change", '#choose-avatar-upload-image-input', function() {

            let filename = this.files[0]['name'];
            let ext = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();

            if (this.files && this.files[0] && (ext == "gif" || ext == "png" || ext == "jpeg" || ext == "jpg")){

                let reader = new FileReader();
                reader.onload = function (e) {
                    that.url = e.target.result;
                    that.base64Image = e.target.result.match(/,(.*)$/)[1];
                    that.close();
                };
                reader.readAsDataURL(this.files[0]);

            }

        });

        $(document).on("click", '.choose-avatar-list-link', function(e) {
            e.preventDefault();

            that.url = $(this).attr('data-link');
            that.toDataUrl(that.url, function(base64Img) {
                that.base64Image = base64Img.match(/,(.*)$/)[1];
                that.close();
            });

            return false;
        });

    }
    
    open(onClose, welcomeScreen = false, targetContainer = null) {

        const that = this;

        this.onClose = onClose;
        this.welcomeScreen = welcomeScreen;
        this.targetContainer = targetContainer;
        this.url = undefined;
        this.base64Image = undefined;

        let context = {
            world: world,
            welcomeScreen: this.welcomeScreen
        };

        if (this.welcomeScreen) {
            $('#welcome-choose-avatar-container').show();
            $('#welcome-choose-avatar-menu').html(this.menuTemplate({title: 'TR_ELIGE_AVATAR', icon: 'close'}));
            $('#welcome-choose-avatar-content').html(this.template(context));
        } else if (this.targetContainer) {
            $(this.targetContainer).empty().append(this.template(context));

            $(this.targetContainer).on('click', '#choose-avatar-upload-image-btn', function(e) {
                e.preventDefault();
                e.stopPropagation();
                document.getElementById('choose-avatar-upload-image-input').click();
            });

            $(this.targetContainer).on('click', '.choose-avatar-list-link', function(e) {
                e.preventDefault();
                e.stopPropagation();

                that.url = $(this).attr('data-link');
                that.toDataUrl(that.url, function(base64Img) {
                    that.base64Image = base64Img.match(/,(.*)$/)[1];
                    that.close();
                });
            });
        } else {
            baseController.resetStackableOrder();
            baseController.stackSimpleMenu({title: 'TR_ELIGE_AVATAR', icon: 'close'}, this.menuTemplate);
            baseController.stackSimpleContent(this.template, context, 'PROFILE');
        }

    }

    close() {

        if (this.welcomeScreen) {
            $('#welcome-choose-avatar-container').hide();
        } else if (this.targetContainer) {
            $(this.targetContainer).empty();
        } else {
            baseController.closeSimpleMenu();
        }

        if (this.onClose) this.onClose(this.url, this.base64Image);

    }

    toDataUrl(url, callback) {
        try {
            let xhr = new XMLHttpRequest();
            if (location.protocol == 'https:') {
                url = url.replace(/http:/g, 'https:');
            }

            xhr.open('GET', url, true);
            xhr.responseType = 'blob';
            xhr.onload = function () {
                var reader = new FileReader();
                reader.onloadend = function () {
                    callback(reader.result);
                };
                reader.readAsDataURL(xhr.response);
            };
            xhr.send();

        } catch (e) {
            console.error(e);
        }
    }

}
